<script setup lang="ts">
import {ref} from 'vue';

import AppMenuItem from './AppMenuItem.vue';
import {EPermissaoSistema} from "@/stores/enums/EPermissaoSistema";
import {useAuthStore} from "@/stores/auth.store";

const authStore = useAuthStore();

const model: any = ref([
  {
    label: 'Home',
    items: [{label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/'}]
  },
  {
    label: 'Menu',
    items: [
      {
        label: "Empresas", icon: "pi pi-fw pi-shop", to: {name: 'empresas'}
      },
      {
        label: 'Colaboradores',
        icon: "pi pi-fw pi-users",
        to: {name: "colaboradores"},
      },
      {
        label: 'Grupo de Permissão',
        icon: "pi pi-fw pi-unlock",
        to: {name: "grupoPermissao"},
      },
      {
        label: 'Seguradora',
        icon: "pi pi-fw pi-building",
        to: {name: "seguradora"},
      },
      {
        label: 'Forma Pagamento',
        icon: "pi pi-fw pi-building",
        to: {name: "formaPagamentoVenda"},
      },
    ]
  },
]);
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>

<style lang="scss" scoped></style>
